
import { defuFn } from 'E:/New/aski-pwa-app-code/aski-pwa-app-code/aski-pwa-app-code/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
